import 'bootstrap'

function handleVideoModalEvents() {
  const videoModalElement = document.getElementById('videoModal')
  const videoModalContentElement = document.getElementById('videoModalContent')

  if (videoModalElement && videoModalContentElement) {
    videoModalElement.addEventListener('show.bs.modal', event => {
      const relatedTarget = event.relatedTarget
      switch (relatedTarget.dataset.videoType) {
        case 'file':
          videoModalContentElement.innerHTML = `<video src="${relatedTarget.dataset.videoFile}" controls autoplay />`
          break
        case 'youtube':
          switch (relatedTarget.dataset.videoYoutubeType) {
            case 'playlist':
              videoModalContentElement.innerHTML = `<iframe src="https://www.youtube.com/embed/videoseries?list=${relatedTarget.dataset.videoYoutubeId}&controls=0&autoplay=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`
              break
            case 'video':
            default:
              videoModalContentElement.innerHTML = `<iframe src="https://www.youtube.com/embed/${relatedTarget.dataset.videoYoutubeId}?controls=0&autoplay=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`
              break
          }
          break
        default:
      }
    })

    videoModalElement.addEventListener('hide.bs.modal', event => {
      videoModalContentElement.innerHTML = ''      
    })
  }
}

document.addEventListener('DOMContentLoaded', (event) => {
  handleVideoModalEvents()
});
